import React, { useContext } from 'react';
import Typography from '@mui/material/Typography';
import Title from '../resources/Title';
import { MainContext } from '../../context/MainContext';
import { format } from "date-fns";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ColouredArc from "./DashboardColouredArc";
import Chip from '@mui/material/Chip';
import SignalCellularAltOutlinedIcon from '@mui/icons-material/SignalCellularAltOutlined';

export default function DashboardTouchpad() {
  const state = useContext(MainContext).state;
  const r2 = state.R2.split(',');
  const r4 = state.R4.split(',');
  const r5 = state.R5.split(',');
  const rg = state.RG.split(',');

  var version = '';
  if (state.deviceType === 1) {
    version = 'V1/2';
  } else if (state.deviceType === 2) {
    version = 'V3';
  }
  var year = r2[11];
  var month = (r2[10].length === 2 ? r2[10] : '0' + r2[10]) === '00' ? '01' : (r2[10].length === 2 ? r2[10] : '0' + r2[10]);
  var day = (r2[9].length === 2 ? r2[9] : '0' + r2[9]) === '00' ? '01' : (r2[9].length === 2 ? r2[9] : '0' + r2[9]);
  var hour = r2[6].length === 2 ? r2[6] : '0' + r2[6];
  var minutes = r2[7].length === 2 ? r2[7] : '0' + r2[7];
  const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const datetime = new Date(year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':00');
  var dayString = weekday[datetime.getDay()];
  var time = format(datetime, "hh:mm a");
  var date = dayString + ' ' + format(datetime, "dd MMMM yyyy");
  var statusList = [];
  if (r5[13] === '1') {
    statusList.push('Auto');
  }
  if (r5[12] === '1') {
    statusList.push('Heating');
  }
  if (r5[11] === '1') {
    statusList.push('Sanitising');
  }
  if (r5[10] === '1') {
    statusList.push('Sleeping');
  }
  if (r4[5] === '2' || r4[5] === '5') {
    statusList.push('Mixing');
  }

  return (
    <Box sx={{ position: "relative", width: "100%", display: "flex", justifyContent: "center" }}>
      {/* Arc as background */}
      <Box sx={{ position: "absolute", top: 40, left: "50%", transform: "translateX(-50%)", zIndex: 0 }}>
        <ColouredArc
          currentTemp={state.R5.split(",")[15] / 10.0}
          setTemp={state.R6.split(",")[8] / 10.0}
          state={1}
        />
      </Box>

      {/* Foreground content */}
      <Box sx={{ position: "relative", zIndex: 1, width: "100%" }}>
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item>
            <Typography component="h2" variant="h6" color="white" gutterBottom>
              {state.deviceName}
            </Typography>
          </Grid>

          <Grid item>
            <Chip
              icon={<SignalCellularAltOutlinedIcon />}
              label={`${state.rssi} dB`}
              size="small"
              sx={{
                mt: "-10px",
                color: 'white',
                '& .MuiChip-icon': {
                  color: 'rgba(129, 199, 132, 1)',
                },
              }}
            />
          </Grid>
        </Grid>

        <Typography component="p" variant="h3" sx={{ textAlign: 'center', mt: 7, color: "rgba(255,255,255,0.7)", }}>
          {state.R5.split(',')[15] / 10.0}°C
        </Typography>
        <Typography color="text.secondary" sx={{ textAlign: 'center', pt: 0.1, color: "rgba(255,255,255,0.7)", }}>
          <strong>{version}</strong>
        </Typography>
        <Typography color="text.secondary" sx={{ textAlign: 'center', color: "rgba(255,255,255,0.7)", }}>
          {time}
        </Typography>
        <Typography color="text.secondary" sx={{ textAlign: 'center', color: "rgba(255,255,255,0.7)", }}>
          {date}
        </Typography>
        {/* Status label */}
        <Typography
          sx={{
            pt: 3,
            color: 'rgba(255,255,255,0.7)',
            fontSize: 16,
            letterSpacing: 1,
          }}
        >
          Status
        </Typography>

        {/* Status chips OR Idle */}
        {statusList.length > 0 ? (
          <Box
            sx={{
              mt: 1,
              display: 'flex',
              flexWrap: 'wrap',
              gap: 0.75,
            }}
          >
            {statusList.map((status) => (
              <Chip
                key={status}
                label={status}
                size="small"
                sx={{
                  bgcolor: 'rgba(255,255,255,0.06)',
                  color: 'rgba(255,255,255,0.9)',
                  fontSize: 11,
                  height: 22,
                }}
              />
            ))}
          </Box>
        ) : (
          <Typography
            sx={{
              mt: 0.5,
              color: 'rgba(255,255,255,0.7)',
              fontSize: 13,
            }}
          >
            Idle
          </Typography>
        )}

      </Box>
    </Box>

  );
}